module.exports = __webpack_public_path__ + "static/img/lg-archive-img-02-03@t.a57ea0f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lg-archive/lg-archive-img-02-03@t.jpg
// module id = nIYY
// module chunks = 0